import React, { useEffect, useState } from 'react'
import { useHomerModal } from './homeModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from "@/views/base/organization/orgModel";
import { assetsMoveService } from '../manage/assetsMove/assetsMoveService'

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel();
    const { searchParam, updateSearchParam, resetSearchParam, loadDataTable } = useHomerModal()
    const { getOrgTreeSelect } = useOrgModel()
    const [departmentOutList, setDepartmentOutList] = useState<any>([]);   //用于搜索展示的数据
    useEffect(() => {
        assetsMoveService.getDepartmentOutList({}).then(({retData})=>{
            if(retData.length>0){
            setDepartmentOutList(retData.filter((list)=>list).map((item)=>{
                return{
                label:item.departmentName,
                value:item.department
            }}))}else{
                setDepartmentOutList([])
            }
            })
}, [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '物资编码',
            fieldName: 'materialCode',
            span:6
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: '物资名称',
            fieldName: 'materialName',
            span:6
        },
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "所属部门",
            fieldName: "department",
            span:6,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: '所属部门',
        //     fieldName: 'department',
        //     options: departmentOutList,
        //     span:3,
        // },
        {
            type: SearchTypeEnum.Select,
            placeholder: '资产状态',
            fieldName: 'status',
            options: getSelectedDictOne(DictCodeEnmu.ASSETS_STATUS),
            span:6,
            showSearch:true,
        },
    ]


    return (
        <YhPageHeader
            style={{margin:0,width: '100%'}}
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadDataTable({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
